import { Text, Heading, Modal, CloseButton } from '@smarterservices/smarter-ui';
import { Button } from '@instructure/ui';
import useSessionStore from '../../stores/session';

const ConfirmReviewExitModal = (props) => {
  const { setEndSessionSid, endSessionSid, endSession } = useSessionStore();

  return (
    <Modal
      open={props.show}
      onDismiss={() => props.onCancel()}
      label="Stop Reviewing Session?"
    >
      <Modal.Header>
        <CloseButton
          placement="end"
          offset="small"
          onClick={() => props.onCancel()}
          screenReaderLabel="Close"
        />
        <Heading>Stop Reviewing Session?</Heading>
      </Modal.Header>
      <Modal.Body>
        <Text>Are you sure you want to stop reviewing this session?</Text>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => props.onConfirmation()} color="primary">
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmReviewExitModal;
